export enum Theme {
  IRONRIDGE = 'ironridge-theme',
  ENSTALL = 'enstall-theme',
  ESDEC = 'esdec-theme',
  ENSTALL_EU = 'enstall-eu-theme',
  ECOFASTENSOLAR = 'ecofasten-theme',
}
